import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/auth/auth.service';
import { LanguageMenuComponent } from '@app/pages/home/language-menu/language-menu.component';
import { AppState } from '@app/store/states/app.state';
import { TranslocoPipe } from '@jsverse/transloco';
import { Credentials } from '@shared/interfaces/credentials';
import { LoadingService } from '@shared/services/loading.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './passkey.component.html',
  imports: [
    TranslocoPipe,
    ReactiveFormsModule,
    MatCardContent,
    MatCard,
    MatFormField,
    MatIcon,
    MatLabel,
    MatInput,
    MatButton,
    LanguageMenuComponent
  ],
  standalone: true
})
export class PasskeyComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly appState = inject(AppState);
  private readonly authService = inject(AuthService);
  private readonly loadingService = inject(LoadingService);
  private readonly router = inject(Router);
  loginForm: FormGroup;
  hide = true;

  ngOnInit() {
    this.loginForm = new FormGroup({
      key: new FormControl('', [Validators.required])
    });
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.loadingService.show();
      const credentials: Credentials = {
        email: this.appState.accountEmail,
        key: this.loginForm.get('key').value
      };

      this.authService
        .finalizeLogin(credentials)
        .pipe(
          tap(() => (this.appState.authenticated = true)),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe({
          next: () => this.router.navigate(['/']),
          error: () => {
            this.loadingService.hide();
          },
          complete: () => this.loadingService.hide()
        });
    }
  }
}
